const ENCODED_FILENAME_PATTERN = /filename\*\s*=\s*UTF-8''([^;]+)/i;
const FILENAME_PATTERN = /filename\s*=\s*"([^"]+)"|filename\s*=\s*([^;]+)/i;

export function getResponseDownloadFilename(
  contentDisposition: string | undefined,
  fallbackFilename: string
): string {
  if (!contentDisposition) return fallbackFilename;
  const encodedMatch = contentDisposition.match(ENCODED_FILENAME_PATTERN);
  if (encodedMatch) return decodeFilename(encodedMatch[1], fallbackFilename);
  const filenameMatch = contentDisposition.match(FILENAME_PATTERN);
  return (
    filenameMatch?.[1]?.trim() || filenameMatch?.[2]?.trim() || fallbackFilename
  );
}

export function triggerBlobDownload(blob: Blob, filename: string): void {
  const url = window.URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.style.display = "none";
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  window.URL.revokeObjectURL(url);
}

function decodeFilename(
  encodedFilename: string,
  fallbackFilename: string
): string {
  try {
    return decodeURIComponent(encodedFilename.trim());
  } catch {
    return fallbackFilename;
  }
}
